// @flow
import type {Node} from 'react'
import React from 'react'
import {useProposalContext} from 'contexts/ProposalContext'

import type {PickAlert, UpdateCallback} from 'components/proposals/types'
import Value from 'components/proposals/Part/ui/Value'
import ValueInput from 'components/proposals/Part/ui/ValueInput'
import type {Circle, Organization} from 'components/proposals/Part/ui/ValueInput'
import DisabledRoleName from './DisabledRoleName'

type Props = $ReadOnly<{
  circle: ?Circle,
  disabled: boolean,
  id: string,
  name: Value,
  onChange: UpdateCallback,
  organization: Organization,
  renderPasteRoleButton: Function,
  strikethrough: boolean,
  pickAlert: PickAlert,
}>

function RoleName({disabled, ...props}: Props): Node {
  const proposalContext = useProposalContext()

  if (disabled) {
    return (
      <DisabledRoleName
        id={props.id}
        rightButton={props.renderPasteRoleButton()}
        strikethrough={props.strikethrough}
        value={props.name.nextValue}
      />
    )
  }

  return (
    <ValueInput
      alert={props.pickAlert('name')}
      containerClassName="mb-3"
      circle={props.circle}
      disabled={disabled}
      id={props.id}
      label={I18n.t('proposals.role_edit.name')}
      onChange={props.onChange}
      organization={props.organization}
      path={['name']}
      rightButton={props.renderPasteRoleButton()}
      strikethrough={props.strikethrough}
      value={props.name}
      aiSuggestProps={props.circle && proposalContext ? {
        context: {type: 'proposal', id: proposalContext?.databaseId},
        promptKey: 'suggest_proposal_role_name',
        data: {
          tensionBody: proposalContext?.tension?.body || '',
          circle: {ref_type: 'Circle', ref_id: props.circle.databaseId},
          // proposal: {ref_type: 'Proposal', ref_id: proposalContext?.proposal?.databaseId},
        },
      } : undefined}
    />
  )
}

RoleName.defaultProps = {
  circle: null,
  renderPasteRoleButton: (): null => null,
  strikethrough: false,
}

export default RoleName
